import { makeApiRequestPromise } from "../../lib/api";
import { RateLimits } from "./types";

export const fetchCurrentUserRateLimits = async (
  domain: string
): Promise<RateLimits> => {
  try {
    const response = await makeApiRequestPromise({
      path: `/api/v1/customers/${encodeURIComponent(domain)}`,
      method: "GET",
    });

    // The standard customers CRUD endpoint returns the Customers model, of which
    // RateLimits is a subset — we only read the rate-limit fields. Access is
    // self-or-staff on the backend; when a staff user is "viewing as" a customer,
    // the auto-attached X-Impersonate-Domain header scopes the read to that
    // tenant (which is also the `domain` we pass here).
    return response as RateLimits;
  } catch (error: any) {
    // Handle specific error cases
    if (error.response) {
      const status = error.response.status;
      const responseData = error.response.data;
      const message = responseData?.detail || error.message;
      
      // Log full error structure for debugging (especially for 404)
      console.error("Rate limits API error structure:", {
        status,
        statusText: error.response.statusText,
        data: responseData,
        headers: error.response.headers,
        fullError: error,
      });
      
      if (status === 401) {
        throw new Error("Authentication required. Please log in.");
      } else if (status === 404) {
        const errorMessage = message || "Rate limits not found for your domain. Please contact support.";
        console.error("Rate limits not found (404):", {
          errorMessage,
          responseData,
          fullError: error,
        });
        throw new Error(errorMessage);
      } else {
        throw new Error(message || "Failed to fetch rate limits");
      }
    }
    
    // Network or other errors
    console.error("Rate limits API network/unknown error:", {
      error,
      errorMessage: error.message,
      errorStack: error.stack,
    });
    throw new Error("Failed to fetch rate limits. Please try again.");
  }
};

